import React from 'react'
import KAMOperatorGroup from './KAMOperatorGroup'
import KAMDataRow from './KAMDataRow'
import { OPERATOR_DISPLAY_ORDER } from './constants'

const KAMRankingTable = ({ 
  groupedData, 
  totalKamCount, 
  onExport 
}) => {
  // Get ordered operators (only those with data)
  const orderedOperators = OPERATOR_DISPLAY_ORDER
    .filter(code => groupedData[code] && groupedData[code].kams.length > 0)

  if (orderedOperators.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <i className="fa-solid fa-users text-gray-400 text-4xl mb-4"></i>
        <p className="text-gray-500">Brak danych wydajności KAM-ów do wyświetlenia.</p>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 flex justify-between items-center border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800">
          <i className="fa-solid fa-chart-bar mr-2 text-blue-500"></i>
          Tabela Wydajności Ogólnej
        </h3>
        <div className="flex items-center space-x-4">
          <span className="text-sm font-medium text-gray-500">
            Łącznie: {totalKamCount} KAM-ów
          </span>
          <button
            onClick={onExport}
            className="px-4 py-2 bg-green-600 text-white text-sm font-semibold rounded-lg shadow-sm hover:bg-green-700 transition-colors"
          >
            <i className="fa-solid fa-file-excel mr-2"></i>
            Eksportuj do XLSX
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wider">
            <tr>
              <th className="px-4 py-3 text-left font-medium">KAM</th>
              <th className="px-4 py-3 text-left font-medium">Region</th>
              <th className="px-4 py-3 text-left font-medium">Operator</th>
              <th className="px-4 py-3 text-right font-medium">Cel MIN</th>
              <th className="px-4 py-3 text-right font-medium">Cel TARGET</th>
              <th className="px-4 py-3 text-right font-medium">Sprzedaż MTD</th>
              <th className="px-4 py-3 text-right font-medium">MTD %</th>
              <th className="px-4 py-3 text-right font-medium">Ostatnie 7 dni</th>
              <th className="px-4 py-3 text-right font-medium">
                Prognoza EOM
                <i className="fa-solid fa-arrow-down ml-1"></i>
              </th>
              <th className="px-4 py-3 text-right font-medium">Wizyty w miesiącu</th>
              <th className="px-4 py-3 text-right font-medium">Unikalne Salony</th>
              <th className="px-4 py-3 text-right font-medium">Ukończone w mies...</th>
              <th className="px-4 py-3 text-right font-medium">Wizyty ogółem</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {orderedOperators.map(opCode => {
              const group = groupedData[opCode]
              if (!group) return null

              return (
                <React.Fragment key={opCode}>
                  {/* Operator Group Header */}
                  <KAMOperatorGroup
                    operatorName={group.name}
                    operatorColor={group.color}
                    bgLight={group.bgLight}
                    borderColor={group.borderColor}
                    textColor={group.textColor}
                    kamCount={group.kams.filter(k => !k.is_unassigned).length}
                    totalGoal={group.totalGoal}
                    totalGoalTarget={group.totalGoalTarget}
                    totalSales={group.totalSales}
                    unassignedSales={group.unassignedSales || 0}
                    achievementPercent={group.achievementPercent}
                    colSpan={13}
                  />
                  
                  {/* KAM Data Rows */}
                  {group.kams.map((kam, idx) => (
                    <KAMDataRow 
                      key={`${opCode}-${idx}`}
                      kam={kam}
                      bgHover={group.bgHover}
                    />
                  ))}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default KAMRankingTable


